export const eventCategoriesAr = {
  Alwadi: "الوادي",
  "Happening Now": "يحدث الان",
  "Upcoming Events": "المناسبات القادمة",
};

export const directoryCategoriesAr = {
  "Fine Dining": "تناول طعام ممتاز",
  "Casual Dining": "عشاء غير رسمي",
  "Cafes and Coffee Shops": "كافيهات ومقاهي",
  Entertainment: "وسائل الترفيه",
  Shopping: "التسوق",
  "Health and Wellness": "الصحة و العافية",
};

export const directoryStatusAr = {
  Available: "متاح",
  "Not Available": "غير متاح",
};
